import BasicModel from "./basic_model";

export default class Goal extends BasicModel {

  w = () => {
    const w = this.size === "large" ? 70 : 35;
    return w * this.context.scale;
  }

  render = function () {
    this.setupContext();

    const x = this.x();
    const y = this.y();
    const w = this.w();
    const s = this.context.scale;

    this.context.beginPath();
    this.context.moveTo(x - w * s, y + 9 * s);
    this.context.lineTo(x - w * s, y - 10 * s);
    this.context.lineTo(x + w * s, y - 10 * s);
    this.context.lineTo(x + w * s, y + 9 * s);
    this.context.strokeStyle = "rgba(255, 255, 255, 1)";
    this.context.lineWidth = 2;
    this.context.setLineDash([2, 5]);
    this.context.stroke();

    this.resetContext()
  }

  boundingBox = function () {
    const w = this.w();
    const x = this.x();
    const y = this.y();

    return {
      x: x - w,
      y: y - 10,
      w: w * 2,
      h: 20
    }
  }

}



